import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebsocketApiService } from '../infra/api.service';

export type ConnectionStatus = 'connecting' | 'connected' | 'disconnected';

@Injectable({ providedIn: 'root', useClass: WebsocketApiService })
export abstract class WebsocketService {
  abstract connect(): void;

  abstract disconnect(): void;

  abstract emit(topic: string, data: unknown): void;

  abstract addListener(
    topic: string,
    listener: (...args: unknown[]) => void
  ): void;

  abstract removeListener(topic: string): void;

  abstract get connectionStatus(): Observable<ConnectionStatus>;
}
